import styled from "styled-components";

const bp = { sm: "560px", md: "768px", lg: "1100px" };

export const Page = styled.section`
  min-height: 100vh;
  padding: 112px 16px 64px;
  background:
    radial-gradient(circle at top, rgba(232, 138, 178, 0.1), transparent 30%),
    radial-gradient(
      circle at top right,
      rgba(201, 162, 39, 0.08),
      transparent 24%
    ),
    linear-gradient(180deg, #fffdfa 0%, #fcf6f0 100%);

  @media (max-width: ${bp.md}) {
    padding: 94px 12px 52px;
  }
`;

export const Inner = styled.div`
  max-width: 1120px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  margin: 0 0 6px;
  font-size: 54px;
  line-height: 0.95;
  color: #171717;
  font-family: "Cormorant Garamond", serif;
  font-weight: 600;

  @media (max-width: ${bp.md}) {
    font-size: 38px;
  }
`;

export const Subtitle = styled.p`
  margin: 0 0 18px;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(23, 23, 23, 0.7);
`;

export const EmptyBox = styled.div`
  margin-top: 18px;
  padding: 20px;
  border-radius: 22px;
  background: #fff;
  border: 1px solid rgba(201, 162, 39, 0.18);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.035);

  @media (max-width: ${bp.md}) {
    padding: 16px;
    border-radius: 18px;
  }
`;

export const BackButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 12px 18px;
  cursor: pointer;
  background: #141414;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
`;

export const TopFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 16px;
`;

export const FilterChip = styled.button`
  border: 1.2px solid
    ${({ $active }) =>
      $active ? "rgba(201,162,39,0.52)" : "rgba(23,23,23,0.12)"};
  background: ${({ $active }) =>
    $active
      ? "linear-gradient(135deg, rgba(201,162,39,0.16) 0%, rgba(255,244,232,1) 100%)"
      : "#fff"};
  color: #171717;
  border-radius: 999px;
  min-height: 38px;
  padding: 0 14px;
  cursor: pointer;
  font-weight: 800;
  font-size: 12px;
  box-shadow: ${({ $active }) =>
    $active ? "0 8px 18px rgba(201,162,39,0.10)" : "none"};
`;

export const OrdersGrid = styled.div`
  display: grid;
  gap: 14px;
`;

export const OrderCard = styled.article`
  background: #fff;
  border: 2px solid
    ${({ $status }) => {
      if ($status === "plata_esuata") return "rgba(210, 55, 55, 0.45)";
      if ($status === "gata") return "rgba(47, 150, 87, 0.45)";
      if ($status === "in_lucru") return "rgba(44, 123, 229, 0.42)";
      if ($status === "confirmata") return "rgba(201, 162, 39, 0.45)";
      if ($status === "anulata") return "rgba(210, 55, 55, 0.45)";
      if ($status === "ridicata" || $status === "livrata")
        return "rgba(32, 120, 73, 0.45)";
      return "rgba(23, 23, 23, 0.12)";
    }};
  border-radius: 24px;
  padding: 18px;
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.08),
    0 6px 12px rgba(0, 0, 0, 0.04);

  transition: all 0.2s ease;

  &:hover {
    box-shadow:
      0 24px 50px rgba(0, 0, 0, 0.12),
      0 10px 20px rgba(201, 162, 39, 0.12);
  }
`;

export const OrderTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;

  @media (max-width: ${bp.md}) {
    gap: 8px;
    margin-bottom: 10px;
  }
`;

export const OrderHeading = styled.div`
  min-width: 0;
  flex: 1;
`;

export const OrderNumber = styled.h2`
  margin: 0 0 3px;
  font-size: 24px;
  color: #171717;
  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  line-height: 1;

  @media (max-width: ${bp.md}) {
    font-size: 12px;
    margin-top: 7px;
  }
`;

export const OrderSubline = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: rgba(23, 23, 23, 0.65);
`;

export const StatusRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;

  @media (max-width: ${bp.md}) {
    justify-content: flex-start;
  }
`;

export const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 12px;

  @media (max-width: ${bp.md}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: ${bp.sm}) {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;

export const MetaItem = styled.div`
  padding: 12px 13px;
  border-radius: 16px;
  background: linear-gradient(180deg, #fffdfa 0%, #fff7f1 100%);
  border: 1.2px solid rgba(201, 162, 39, 0.2);
  box-shadow: 0 4px 10px rgba(23, 17, 13, 0.03);

  strong {
    display: block;
    margin-bottom: 4px;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(23, 23, 23, 0.62);
  }

  span {
    color: #171717;
    font-size: 13px;
    line-height: 1.4;
    font-weight: 700;
  }
`;

export const SectionTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 18px;
  color: #171717;
  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
`;

export const ProductsList = styled.div`
  display: grid;
  gap: 8px;
`;

export const ProductRow = styled.div`
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  padding: 10px 11px;
  border-radius: 15px;
  background: #fffdfa;
  border: 1px solid rgba(23, 23, 23, 0.06);

  @media (max-width: ${bp.md}) {
    grid-template-columns: 52px minmax(0, 1fr) auto;
    padding: 9px 10px;
    gap: 8px;
  }

  @media (max-width: ${bp.sm}) {
    grid-template-columns: 52px minmax(0, 1fr);
  }
`;

export const ProductImg = styled.img`
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid rgba(201, 162, 39, 0.14);

  @media (max-width: ${bp.md}) {
    width: 52px;
    height: 52px;
  }
`;

export const ProductInfo = styled.div`
  min-width: 0;
`;

export const ProductName = styled.h4`
  margin: 0 0 3px;
  font-size: 16px;
  font-family: "Cormorant Garamond", serif;
  font-weight: 700;
  color: #171717;
  line-height: 1.15;
`;

export const ProductMeta = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 1.35;
  color: rgba(23, 23, 23, 0.68);
`;

export const ProductPrice = styled.div`
  white-space: nowrap;
  font-size: 15px;
  font-weight: 800;
  color: #171717;
  align-self: center;

  @media (max-width: ${bp.sm}) {
    grid-column: 2 / 3;
    justify-self: start;
    margin-top: 2px;
    font-size: 14px;
  }
`;

export const BottomGrid = styled.div`
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 12px;
  margin-top: 12px;

  @media (max-width: ${bp.md}) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const Panel = styled.div`
  padding: 13px;
  border-radius: 17px;
  background: linear-gradient(180deg, #ffffff 0%, #fffaf4 100%);
  border: 1.2px solid rgba(201, 162, 39, 0.22);
  box-shadow:
    0 8px 18px rgba(23, 17, 13, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);

  @media (max-width: ${bp.md}) {
    padding: 12px;
  }
`;

export const Timeline = styled.div`
  display: grid;
  gap: 8px;
`;

export const TimelineItem = styled.div`
  padding: 10px 12px;
  border-radius: 14px;
  background: linear-gradient(180deg, #fffdfa 0%, #fff8f2 100%);
  border: 1px solid rgba(201, 162, 39, 0.16);

  strong {
    display: block;
    margin-bottom: 3px;
    font-size: 12px;
    color: #171717;
    line-height: 1.3;
  }

  span {
    display: block;
    font-size: 11px;
    line-height: 1.42;
    color: rgba(23, 23, 23, 0.7);
  }
`;

export const NoteBox = styled.textarea`
  width: 100%;
  min-height: 84px;
  resize: vertical;
  border-radius: 14px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: #fffdfa;
  padding: 11px 12px;
  font: inherit;
  font-size: 13px;
  color: #171717;
  outline: none;

  &:focus {
    border-color: rgba(201, 162, 39, 0.34);
    box-shadow: 0 0 0 4px rgba(201, 162, 39, 0.08);
  }
`;

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
`;

export const ActionBtn = styled.button`
  border: 1px solid
    ${({ $dark }) => ($dark ? "rgba(23,23,23,0.92)" : "rgba(201,162,39,0.24)")};
  background: ${({ $dark }) =>
    $dark
      ? "linear-gradient(135deg, #171717 0%, #2a211d 100%)"
      : "linear-gradient(135deg, #fff 0%, #fff7f0 100%)"};
  color: ${({ $dark }) => ($dark ? "#fff" : "#171717")};
  border-radius: 999px;
  min-height: 38px;
  padding: 0 13px;
  cursor: pointer;
  font-weight: 800;
  font-size: 11px;
  line-height: 1;
  box-shadow: ${({ $dark }) =>
    $dark ? "0 8px 18px rgba(0,0,0,0.12)" : "0 6px 14px rgba(201,162,39,0.06)"};

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }
`;

export const TotalRow = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed rgba(201, 162, 39, 0.35);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  strong {
    font-size: 12px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(23, 23, 23, 0.6);
  }

  span {
    font-size: 20px;
    font-weight: 800;
    color: #171717;
    font-family: "Cormorant Garamond", serif;
    line-height: 1;
  }
`;

export const ClosePageButton = styled.button`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 99999;

  width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(201, 162, 39, 0.38);

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(25, 22, 20, 0.92);
  color: #ff77b4;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 10px 24px rgba(0, 0, 0, 0.24);

  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(252, 154, 196, 0.7);
    background: rgba(38, 32, 30, 0.98);
  }

  @media (max-width: ${bp.md}) {
    width: 40px;
    height: 40px;
    top: 12px;
    right: 12px;
    font-size: 24px;
  }
`;

export const StatusSignal = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 5px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  color: ${({ $status }) => {
    if ($status === "plata_esuata") return "#d23737";
    if ($status === "gata") return "#2f9657";
    if ($status === "in_lucru") return "#2c7be5";
    if ($status === "confirmata") return "#b78a00";
    if ($status === "anulata") return "#d23737";
    if ($status === "ridicata" || $status === "livrata") return "#207849";
    return "rgba(23,23,23,0.6)";
  }};

  &::before {
    content: "";
    width: 9px;
    height: 9px;
    border-radius: 999px;
    background: ${({ $status }) => {
      if ($status === "plata_esuata") return "#d23737";
      if ($status === "gata") return "#2f9657";
      if ($status === "in_lucru") return "#2c7be5";
      if ($status === "confirmata") return "#c9a227";
      if ($status === "anulata") return "#d23737";
      if ($status === "ridicata" || $status === "livrata") return "#207849";
      return "#c9a227";
    }};
  }
`;

export const DetailsToggle = styled.button`
  border: 1px solid rgba(201, 162, 39, 0.26);
  background: #fff;
  border-radius: 999px;
  min-height: 36px;
  padding: 0 14px;
  cursor: pointer;
  font-weight: 700;
  font-size: 11px;
  margin-top: 12px;
`;

export const DetailsWrap = styled.div`
  margin-top: 14px;
`;
